import React from 'react'
import { CompanyCredentials } from '@shared/components/company-credentials'
import { Video } from '@shared/components/video'

import { data } from './data'

import styles from './styles.module.scss'

export const View = () => {
	return (
		<article className={styles.tab}>
			<div className={styles.contentWrapper}>
				<h2 className={styles.heading}>{data.heading}</h2>
				<p className={styles.content}>{data.firstContent}</p>
				<p className={styles.content}>{data.secondContent}</p>
				<p className={`${styles.content} ${styles.thirdContent}`}>{data.thirdContent}</p>
				<Video src='/videos/about-company.mp4' poster='/images/cc-company-video-poster.jpg' />
				<p className={`${styles.content} ${styles.fourthContent}`}>{data.fourthContent}</p>
			</div>

			<div className={styles.card}>
				<CompanyCredentials
					ooo='ООО «Кредит.Клаб»'
					startYear='2019'
					inn='6678105594'
					withoutReestr
					withOperation
				/>
			</div>
		</article>
	)
}
